import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { UnitOfMeasureModel } from '@/libs/Api';
import { UnitOfMeasuresDataService } from '@/libs/unit-of-measure/unit-of-measures-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const scrapCausesStore = registerCrudStore<UnitOfMeasureModel, UnitOfMeasureModel>(
    BusinessModule.UnitOfMeasure,
    new UnitOfMeasuresDataService()
);